var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 7.2C18.4 6.8 18.2 6.3 18.2 5.8C18.2 4.7 17.7 3.7 17 3C16.3 2.3 15.3 1.8 14.2 1.8C13.7 1.8 13.2 1.6 12.8 1.2C11.6138 -0.0652619 9.73975 -0.329969 8.21629 0.405879C7.39123 0.804394 6.82239 1.74425 5.90763 1.79691C5.87181 1.79897 5.8359 1.8 5.8 1.8C3.6 1.8 1.8 3.6 1.8 5.8C1.8 6.3 1.6 6.8 1.2 7.2C-0.4 8.7 -0.4 11.3 1.2 12.8C1.6 13.2 1.8 13.7 1.8 14.2C1.8 15.3 2.3 16.3 3 17C3.7 17.7 4.7 18.2 5.8 18.2C6.3 18.2 6.8 18.4 7.2 18.8C8 19.6 9 20 10 20C11 20 12 19.6 12.8 18.8C13.2 18.4 13.7 18.2 14.2 18.2C16.4 18.2 18.2 16.4 18.2 14.2C18.2 13.1947 19.1723 12.5098 19.6104 11.605C20.3138 10.1521 20.0286 8.35177 18.8 7.2Z",
    fill: "var(--discount-icon-fill, url(#paint0_linear_12_499))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
    fill: "#FCFCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9Z",
    fill: "#FCFCFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13C7.7 13 7.5 12.9 7.3 12.7C6.9 12.3 6.9 11.7 7.3 11.3L11.3 7.3C11.7 6.9 12.3 6.9 12.7 7.3C13.1 7.7 13.1 8.3 12.7 8.7L8.7 12.7C8.5 12.9 8.3 13 8 13Z",
    fill: "#FCFCFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.8 12.7969C18.4 13.1969 18.2 13.6969 18.2 14.1969C18.2 16.3969 16.4 18.1969 14.2 18.1969C13.7 18.1969 13.2 18.3969 12.8 18.7969C12 19.5969 11 19.9969 10 19.9969C9 19.9969 8 19.5969 7.2 18.7969C6.8 18.3969 6.3 18.1969 5.8 18.1969C4.7 18.1969 3.7 17.6969 3 16.9969L7.4 12.5969L12.8 7.19687L17.2 2.79688C17.9 3.49687 18.4 4.49687 18.4 5.59687C18.4 6.09687 18.6 6.59687 19 6.99687C20.4 8.69687 20.4 11.2969 18.8 12.7969Z",
    fill: "#100E15"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_499",
    x1: 9.99389,
    y1: 0,
    x2: 9.99389,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF857A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF626F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/Discount.a1ee3be9925a97757eb78c23011a9b31.svg";
export { ForwardRef as ReactComponent };